<div class="asset-details-root">
    <div class="asset-details-header">
        <div class="row">
            <div class="asset-header-back-button col-auto" (click)="backClicked()">
                <button class="action-button">
                <svg
                    width="15"
                    height="12"
                    viewBox="0 0 15 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                    d="M5.71 1.28906L1 5.99906L5.71 10.7091M1.5652 5.99906H13.4344"
                    stroke="#17171A"
                    stroke-opacity="0.9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    />
                </svg>
                </button>
            </div>
            <div class="asset-header-info col-4">
                <div class="row">
                <div class="col-12 header-title">
                    <b> {{title}} {{ "CRUD.NAME" | translate }}</b>
                </div>
                <div class="light-gray-text col-auto">
                    {{ selectedEquipment?.name }} 
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="asset-details-content">
        <div class="row">
            <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
                <div class="asset-card col-12" [ngClass]="networkCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                    <div class="asset-card-header row">
                        <h2 class="card-title asset-card-title col-10">
                            {{ "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.TITLE" | translate }}
                        </h2>
                        <div class="collapse-arrow col-2">
                            <button
                                class="action-button"
                                (click)="networkCardExpanded = true"
                                *ngIf="!networkCardExpanded"
                            >
                                <svg
                                width="10"
                                height="6"
                                viewBox="0 0 10 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    d="M1 1L5 5L9 1"
                                    stroke="#17171A"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                </svg>
                            </button>
                            <button
                                class="action-button"
                                (click)="networkCardExpanded = false"
                                *ngIf="networkCardExpanded"
                            >
                                <svg
                                width="10"
                                height="6"
                                viewBox="0 0 10 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    d="M9 5L5 1L1 5"
                                    stroke="#17171A"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div
                        *ngIf="networkCardExpanded"
                        class="asset-card-content"
                        @slideToggle
                    >
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> 
                                Name 
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.name | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> 
                                Substation Template Name 
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.substationTemplateName | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> 
                                Substation Name 
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.substationName | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title"> 
                                Substation Number 
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationNumber | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> 
                                Substation Asset Status 
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.substationAssetStatus | hasValue }}
                            </div>
                        </div>
                        <div *ngIf="cimClass !== 1" class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> 
                                Base Voltage 
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.baseVoltage | hasValue }}
                            </div>
                        </div>
                        <div *ngIf="cimClass === 1"  class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> 
                                Primary Winding 
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.primaryWinding | hasValue }}
                            </div>
                        </div>
                        <div *ngIf="cimClass === 1" class="asset-card-info row">
                            <div class="col-5 asset-card-content-title"> 
                                Secondary Winding 
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.secondaryWinding | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-6 asset-card-content-title"> 
                                Sub Geographical Region 
                            </div>
                            <div class="col-6 asset-card-content-value">
                                {{ selectedEquipment?.subGeographicalRegion | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title"> 
                                Geographical Region 
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.geographicalRegion | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title">
                                {{'MV_POLES.GEOLOCATION' | translate}}
                            </div>
                            <div class="col-6 asset-card-content-value">
                                {{ selectedEquipment?.substationLatitude }}, {{selectedEquipment?.substationLongitude }}
                            </div>
                            <div class="geo-icon col-auto" (click)="isMapVisible = !isMapVisible">
                                <svg width="16" height="16" viewBox="0 0 16 16" data-bs-toggle="modal"
                                    data-bs-target="#showMap" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8 0C8.30376 0 8.55479 0.225723 8.59452 0.518583L8.6 0.6L8.59925 2.03017C11.4343 2.31006 13.6899 4.56575 13.9706 7.40203L14 7.4H15.4C15.7314 7.4 16 7.66863 16 8C16 8.30376 15.7743 8.55479 15.4814 8.59452L15.4 8.6L13.9693 8.59923C13.6899 11.4343 11.4343 13.6899 8.59797 13.9706L8.6 14V15.4C8.6 15.7314 8.33137 16 8 16C7.69624 16 7.44521 15.7743 7.40548 15.4814L7.4 15.4L7.40077 13.9693C4.56575 13.6899 2.31006 11.4343 2.02942 8.59797L2 8.6H0.6C0.268629 8.6 0 8.33137 0 8C0 7.69624 0.225723 7.44521 0.518583 7.40548L0.6 7.4L2.03017 7.40075C2.31006 4.56575 4.56575 2.31006 7.40203 2.02942L7.4 2V0.6C7.4 0.268629 7.66863 0 8 0ZM8 3.2C5.34903 3.2 3.2 5.34903 3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2ZM8 4.8C9.76731 4.8 11.2 6.23269 11.2 8C11.2 9.76731 9.76731 11.2 8 11.2C6.23269 11.2 4.8 9.76731 4.8 8C4.8 6.23269 6.23269 4.8 8 4.8Z"
                                        fill="var(--primary-color)" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="asset-card col-12" [ngClass]="userActionsCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                    <div class="asset-card-header row">
                        <h2 class="card-title asset-card-title col-10">
                            {{ "MV_POLES.USER_ACTIVITY" | translate }}
                        </h2>
                        <div class="collapse-arrow col-2">
                            <button
                                class="action-button"
                                (click)="userActionsCardExpanded = true"
                                *ngIf="!userActionsCardExpanded"
                            >
                                <svg
                                width="10"
                                height="6"
                                viewBox="0 0 10 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    d="M1 1L5 5L9 1"
                                    stroke="#17171A"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                </svg>
                            </button>
                            <button
                                class="action-button"
                                (click)="userActionsCardExpanded = false"
                                *ngIf="userActionsCardExpanded"
                            >
                                <svg
                                width="10"
                                height="6"
                                viewBox="0 0 10 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    d="M9 5L5 1L1 5"
                                    stroke="#17171A"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div
                        *ngIf="userActionsCardExpanded"
                        class="asset-card-content"
                        @slideToggle
                    >
                        <div class="asset-card-info row">
                            <div class="col-6 asset-card-content-title"> 
                                First Captured User 
                            </div>
                            <div class="col-6 asset-card-content-value">
                                {{ selectedEquipment?.substationFirstCapturedUser | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title"> 
                                Last Updated User 
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationLastUpdatedUser | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title">
                                Creation Date
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.substationCreationDate | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-6 asset-card-content-title"> 
                                Last Update Time 
                            </div>
                            <div class="col-6 asset-card-content-value">
                                {{ selectedEquipment?.substationLastUpdateTime | hasValue }}
                            </div>
                        </div>
                       <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title"> 
                                {{ "COMMON.USER.TYPE.REASSIGNED" | translate }} 
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationReassignedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-5 asset-card-content-title">
                                {{ "COMMON.MBC_DETAILS.ASSIGNED" | translate }}
                            </div>
                            <div class="col-7 asset-card-content-value">
                                {{ selectedEquipment?.substationAssignedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.VALIDATION_STATUS" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationValidationStatus | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.USER.TYPE.VALIDATED" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationValidatedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.DATE_TYPE.VALIDATED" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationValidationDate | date:'dd/MM/yyyy':'{{ timeZone }}' | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.MBC_DETAILS.AUDITED_STATUS" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationAuditedStatus | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.USER.TYPE.AUDITED" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationAuditedBy | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.MBC_DETAILS.AUDITED_DATE" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationAuditedDateTime | hasValue }}
                            </div>
                        </div>
                        <div class="asset-card-info row">
                            <div class="col-7 asset-card-content-title">
                                {{ "COMMON.REVIEW_STATUS" | translate }}
                            </div>
                            <div class="col-5 asset-card-content-value">
                                {{ selectedEquipment?.substationReviewStatus | hasValue }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
                <lib-section-instance-column
                [sections]="sectionInstances"
                columnAlign="center"
                (mapClicked)="setClickedLocation($event)"
                >
                </lib-section-instance-column>
            </div> 
            <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
                <lib-section-instance-column
                [sections]="sectionInstances"
                columnAlign="right"
                (mapClicked)="setClickedLocation($event)"
                >
                </lib-section-instance-column>
            </div> 
        </div>
    </div>
</div>


<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          #closeAddModal
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <lib-asset-map
          [setMapVisibility]="isMapVisible"
          [longitude]="selectedEquipment?.substationLongitude"
          [latitude]="selectedEquipment?.substationLatitude"
        >
        </lib-asset-map>
      </div>
    </div>
  </div>
</div>